<div class="total-score-container">
    <div class="total-score-value">{{ value() }}</div>
    <div>{{ label() }}</div>
</div>


